import React, { useState, useEffect } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import TableWithFilters from "../../../components/filtersNew/table-with-filtersNew";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";
import { useTranslation } from "react-i18next";

export default function Paises({ user }) {
    const { t } = useTranslation();
    const [paises, setPaises] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    useEffect(() => {
        fetchPaises();
    }, [selectedZone]);

    const fetchPaises = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaisesByZona/${selectedZone.value}`
            );
            paisesData = response.data;

            console.log("Paises data fetched:", paisesData);

            //setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
            setPaises(paisesData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const columnasPaises = [
        {
            key: "codPais",
            label: t("countries.country"),
            sortable: true,
            visible: false,
        },
        {
            key: "pais",
            label: t("fields.country"),
            sortable: true,
            visible: true,
        },
    ];

    const filterFields = [
        { key: "pais", label: "fields.country", type: "multiselect" },
    ];

    if (error)
        return (
            <div className="muebles-pages__error-message">Error: {error}</div>
        );

    return (
        <PageLayout
            title={t("countries.title")}
            subtitle={t("countries.subtitle")}
        >
            <TableWithFilters
                quickFields={["pais"]}
                columns={columnasPaises}
                dataTable={paises}
                showCheckboxes={false}
                actions={["Eliminar", "Editar"]}
                noResultsMessage={t("countries.noCountriesFound")}
                searchTerms={[t("fields.country")]}
                formElements={[
                    {
                        elements: [
                            {
                                name: "pais",
                                type: "text",
                                label: t("fields.country"),
                                placeholder: t("placeholders.enterCountry"),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codZona",
                                type: "number",
                                label: "Zona",
                                placeholder: "Introduce la zona",
                                required: true,
                                disabled: false,
                                labelVisible: false,
                                visible: false,
                                defaultValue: selectedZone.value,
                            },
                        ],
                    },
                ]}
                filterFields={filterFields}
                loading={loading}
                elementName={t("fields.country")}
                keyProp="codPais"
                sortProp="pais"
                addApiUrl="/api/Paises/SetPais"
                editApiUrl="/api/Paises/EditPais"
                deleteApiUrl="/api/Paises/DeletePais"
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
            />
        </PageLayout>
    );
}
